module.exports = __webpack_public_path__ + "resources/img/logo_nhn_kcp.d72c1dc1c8c99e8f8177cc33ababa470.png";